import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\Timestamp.tsx.esbuild-plugin-windicss.css';
import { memo } from 'preact/compat';
import { i18n } from '../i18n';
export const Timestamp = memo(({
  timestamp,
  finalized,
  height
}: {
  timestamp: number;
  finalized?: unknown;
  height: number;
}) => {
  const timestampString = `${i18n.formatDateTime(timestamp, {
    year: true
  })} ${finalized ? i18n.finalized : i18n.updated}`;
  return timestampString ? <>
      <text class="pointer-events-none" x={9.2} y={height - 10} font-size={16} fill="white" children={timestampString} />
      <text class="pointer-events-none" x={10} y={height - 9.2} font-size={16} fill="black" children={timestampString} />
    </> : null;
});